module.exports = __webpack_public_path__ + "static/media/agentHeader.1737b1d1.svg";